var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { locked: _vm.token === null } },
    [
      _c("ul", { staticClass: "title-nav" }, [
        _c(
          "li",
          {
            on: {
              click: function($event) {
                return _vm.handleBack()
              }
            }
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "title-label" }, [
              _c("i", { staticClass: "material-icons md-18" }, [
                _vm._v("assignment")
              ]),
              _vm._v(" ZONING (" + _vm._s(_vm.parcel.zoning.length) + ")")
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _vm.token === null
        ? _c(
            "div",
            { staticClass: "lock-block", on: { click: _vm.routeLogin } },
            [_vm._m(1), _vm._v(" "), _vm._m(2)]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.parcel.zoning.length === 0
        ? _c("div", { staticClass: "section-title text-center" }, [
            _vm._v("\n\t\tNo zoning info for this parcel\n\t")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.parcel.zoning, function(zone, index) {
        return _c("div", { staticClass: "mb-3" }, [
          _c("div", { staticClass: "section" }, [
            _c("div", { staticClass: "section-title" }, [
              _c(
                "span",
                {
                  staticClass: "link",
                  on: {
                    click: function($event) {
                      return _vm.routeZoning(zone)
                    }
                  }
                },
                [_vm._v(_vm._s(zone.designation))]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "section-body" },
              [
                _c("div", { staticClass: "category" }, [
                  _c("div", { staticClass: "category-title" }, [
                    _vm._v("DESCRIPTION")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "property-row" }, [
                    _c("div", { staticClass: "text-break property-locked" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t" +
                          _vm._s(
                            zone.description || "No description available"
                          ) +
                          "\n\t\t\t\t\t\t"
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm._l(zone.regulations, function(regulation, regInd) {
                  return _c("div", [
                    regulation.lotSize.minArea !== null ||
                    regulation.lotSize.maxArea !== null ||
                    regulation.lotSize.minWidth !== null ||
                    regulation.lotSize.minWidthCorner !== null ||
                    regulation.lotSize.minFrontage !== null ||
                    regulation.lotSize.minDepth !== null
                      ? _c("div", { staticClass: "category" }, [
                          _c("div", { staticClass: "category-title" }, [
                            _vm._v("LOT SIZE")
                          ]),
                          _vm._v(" "),
                          regulation.lotSize.minArea !== null
                            ? _c("div", { staticClass: "property-row" }, [
                                _c("label", [_vm._v("Minimum area")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "property-value-right property-locked"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm._f("integerLg")(
                                            regulation.lotSize.minArea
                                          )
                                        ) +
                                        " ft\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          regulation.lotSize.maxArea !== null
                            ? _c("div", { staticClass: "property-row" }, [
                                _c("label", [_vm._v("Maximum area")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "property-value-right property-locked"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm._f("integerLg")(
                                            regulation.lotSize.maxArea
                                          )
                                        ) +
                                        " ft\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          regulation.lotSize.minWidth !== null
                            ? _c("div", { staticClass: "property-row" }, [
                                _c("label", [_vm._v("Minimum width")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "property-value-right property-locked"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm._f("integerLg")(
                                            regulation.lotSize.minWidth
                                          )
                                        ) +
                                        " ft\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          regulation.lotSize.minWidthCorner !== null
                            ? _c("div", { staticClass: "property-row" }, [
                                _c("label", [_vm._v("Minimum width corner")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "property-value-right property-locked"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm._f("integerLg")(
                                            regulation.lotSize.minWidthCorner
                                          )
                                        ) +
                                        " ft\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          regulation.lotSize.minFrontage !== null
                            ? _c("div", { staticClass: "property-row" }, [
                                _c("label", [_vm._v("Minimum frontage")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "property-value-right property-locked"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm._f("integerLg")(
                                            regulation.lotSize.minFrontage
                                          )
                                        ) +
                                        " ft\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          regulation.lotSize.minDepth !== null
                            ? _c("div", { staticClass: "property-row" }, [
                                _c("label", [_vm._v("Minimum depth")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "property-value-right property-locked"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm._f("integerLg")(
                                            regulation.lotSize.minDepth
                                          )
                                        ) +
                                        " ft\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    regulation.density.sfDu !== null
                      ? _c("div", { staticClass: "category" }, [
                          _c("div", { staticClass: "category-title" }, [
                            _vm._v("DENSITY")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "property-row" }, [
                            _c("label", [_vm._v("SF/DU")]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "property-value-right property-locked"
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm._f("integerLg")(
                                        regulation.density.sfDu
                                      )
                                    ) +
                                    "\n\t\t\t\t\t\t\t"
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          regulation.density.sfDuNote !== null
                            ? _c("div", { staticClass: "property-row" }, [
                                _c("label", [_vm._v("SF/DU note")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "property-value-right property-locked"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(regulation.density.sfDuNote) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    regulation.heightLimit.max !== null ||
                    regulation.heightLimit.aboveEnclosedParking !== null ||
                    regulation.heightLimit.roofFlat !== null ||
                    regulation.heightLimit.roofPitched !== null
                      ? _c("div", { staticClass: "category" }, [
                          _c("div", { staticClass: "category-title" }, [
                            _vm._v("HEIGHT LIMIT")
                          ]),
                          _vm._v(" "),
                          regulation.heightLimit.max !== null
                            ? _c("div", { staticClass: "property-row" }, [
                                _c("label", [_vm._v("Height maximum")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "property-value-right property-locked"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm._f("integerLg")(
                                            regulation.heightLimit.max
                                          )
                                        ) +
                                        " ft\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          regulation.heightLimit.aboveEnclosedParking !== null
                            ? _c("div", { staticClass: "property-row" }, [
                                _c("label", [_vm._v("Above enclosed parking")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "property-value-right property-locked"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm._f("integerLg")(
                                            regulation.heightLimit
                                              .aboveEnclosedParking
                                          )
                                        ) +
                                        " ft\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          regulation.heightLimit.roofFlat !== null
                            ? _c("div", { staticClass: "property-row" }, [
                                _c("label", [_vm._v("Roof flat limit")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "property-value-right property-locked"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm._f("integerLg")(
                                            regulation.heightLimit.roofFlat
                                          )
                                        ) +
                                        " ft\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          regulation.heightLimit.roofPitched !== null
                            ? _c("div", { staticClass: "property-row" }, [
                                _c("label", [_vm._v("Roof pitched limit")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "property-value-right property-locked"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm._f("integerLg")(
                                            regulation.heightLimit.roofPitched
                                          )
                                        ) +
                                        " ft\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          regulation.heightLimit.note !== null
                            ? _c("div", { staticClass: "property-row" }, [
                                _c("label", [_vm._v("Height note")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "property-value-right property-locked"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(regulation.heightLimit.note) +
                                        " ft\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    regulation.far.base !== null ||
                    regulation.far.min !== null ||
                    regulation.far.max !== null ||
                    regulation.far.residential !== null ||
                    regulation.far.commercial !== null ||
                    regulation.far.mixed !== null
                      ? _c("div", { staticClass: "category" }, [
                          _c("div", { staticClass: "category-title" }, [
                            _vm._v("FLOOR TO AREA RATIO (FAR)")
                          ]),
                          _vm._v(" "),
                          regulation.far.base !== null
                            ? _c("div", { staticClass: "property-row" }, [
                                _c("label", [_vm._v("FAR base")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "property-value-right property-locked"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(regulation.far.base) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          regulation.far.min !== null
                            ? _c("div", { staticClass: "property-row" }, [
                                _c("label", [_vm._v("FAR minimum")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "property-value-right property-locked"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(regulation.far.min) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          regulation.far.max !== null
                            ? _c("div", { staticClass: "property-row" }, [
                                _c("label", [_vm._v("FAR maximum")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "property-value-right property-locked"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(regulation.far.max) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          regulation.far.residential !== null
                            ? _c("div", { staticClass: "property-row" }, [
                                _c("label", [_vm._v("FAR residential")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "property-value-right property-locked"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(regulation.far.residential) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          regulation.far.commercial !== null
                            ? _c("div", { staticClass: "property-row" }, [
                                _c("label", [_vm._v("FAR commercial")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "property-value-right property-locked"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(regulation.far.commercial) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          regulation.far.mixed !== null
                            ? _c("div", { staticClass: "property-row" }, [
                                _c("label", [_vm._v("FAR mixed")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "property-value-right property-locked"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(regulation.far.mixed) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          regulation.far.note !== null
                            ? _c("div", { staticClass: "property-row" }, [
                                _c("label", [_vm._v("FAR note")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "property-value-right property-locked"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(regulation.far.note) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    regulation.setbacks.frontMin !== null ||
                    regulation.setbacks.frontMax !== null ||
                    regulation.setbacks.interiorSide !== null ||
                    regulation.setbacks.streetSide !== null ||
                    regulation.setbacks.rear !== null ||
                    regulation.setbacks.rearAlley !== null ||
                    regulation.setbacks.rearAlley !== null ||
                    regulation.setbacks.generalNote !== null
                      ? _c("div", { staticClass: "category" }, [
                          _c("div", { staticClass: "category-title" }, [
                            _vm._v("SETBACKS")
                          ]),
                          _vm._v(" "),
                          regulation.setbacks.frontMin !== null
                            ? _c("div", { staticClass: "property-row" }, [
                                _c("label", [_vm._v("Front minimum")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "property-value-right property-locked"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm._f("integerLg")(
                                            regulation.setbacks.frontMin
                                          )
                                        ) +
                                        " ft\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          regulation.setbacks.frontMinNote !== null
                            ? _c("div", { staticClass: "property-row" }, [
                                _c("label", [_vm._v("Front minimum note")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "property-value-right property-locked"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          regulation.setbacks.frontMinNote
                                        ) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          regulation.setbacks.frontMax !== null
                            ? _c("div", { staticClass: "property-row" }, [
                                _c("label", [_vm._v("Front maximum")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "property-value-right property-locked"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm._f("integerLg")(
                                            regulation.setbacks.frontMax
                                          )
                                        ) +
                                        " ft\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          regulation.setbacks.frontMaxNote !== null
                            ? _c("div", { staticClass: "property-row" }, [
                                _c("label", [_vm._v("Front maximum note")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "property-value-right property-locked"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          regulation.setbacks.frontMaxNote
                                        ) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          regulation.setbacks.interiorSide !== null
                            ? _c("div", { staticClass: "property-row" }, [
                                _c("label", [_vm._v("Interior side")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "property-value-right property-locked"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm._f("integerLg")(
                                            regulation.setbacks.interiorSide
                                          )
                                        ) +
                                        " ft\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          regulation.setbacks.interiorSideNote !== null
                            ? _c("div", { staticClass: "property-row" }, [
                                _c("label", [_vm._v("Interior side note")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "property-value-right property-locked"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          regulation.setbacks.interiorSideNote
                                        ) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          regulation.setbacks.streetSide !== null
                            ? _c("div", { staticClass: "property-row" }, [
                                _c("label", [_vm._v("Street side")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "property-value-right property-locked"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm._f("integerLg")(
                                            regulation.setbacks.streetSide
                                          )
                                        ) +
                                        " ft\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          regulation.setbacks.streetSideNote !== null
                            ? _c("div", { staticClass: "property-row" }, [
                                _c("label", [_vm._v("Street side note")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "property-value-right property-locked"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          regulation.setbacks.streetSideNote
                                        ) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          regulation.setbacks.rear !== null
                            ? _c("div", { staticClass: "property-row" }, [
                                _c("label", [_vm._v("Rear")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "property-value-right property-locked"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm._f("integerLg")(
                                            regulation.setbacks.rear
                                          )
                                        ) +
                                        " ft\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          regulation.setbacks.rearAlley !== null
                            ? _c("div", { staticClass: "property-row" }, [
                                _c("label", [_vm._v("Rear")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "property-value-right property-locked"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm._f("integerLg")(
                                            regulation.setbacks.rearAlley
                                          )
                                        ) +
                                        " ft\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          regulation.setbacks.rearNote !== null
                            ? _c("div", { staticClass: "property-row" }, [
                                _c("label", [_vm._v("Rear note")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "property-value-right property-locked"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(regulation.setbacks.rearNote) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          regulation.setbacks.generalNote !== null
                            ? _c("div", { staticClass: "property-row" }, [
                                _c("label", [_vm._v("General note")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "property-value-right property-locked"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          regulation.setbacks.generalNote
                                        ) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    regulation.lotCoverage.min !== null ||
                    regulation.lotCoverage.max !== null
                      ? _c("div", { staticClass: "category" }, [
                          _c("div", { staticClass: "category-title" }, [
                            _vm._v("LOT COVERAGE")
                          ]),
                          _vm._v(" "),
                          regulation.lotCoverage.min !== null
                            ? _c("div", { staticClass: "property-row" }, [
                                _c("label", [_vm._v("Lot coverage minimum")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "property-value-right property-locked"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm._f("integerLg")(
                                            regulation.lotCoverage.min
                                          )
                                        ) +
                                        " ft\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          regulation.lotCoverage.max !== null
                            ? _c("div", { staticClass: "property-row" }, [
                                _c("label", [_vm._v("Lot coverage maximum")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "property-value-right property-locked"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm._f("integerLg")(
                                            regulation.lotCoverage.max
                                          )
                                        ) +
                                        " ft\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          regulation.lotCoverage.note !== null
                            ? _c("div", { staticClass: "property-row" }, [
                                _c("label", [_vm._v("Lot coverage note")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "property-value-right property-locked"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(regulation.lotCoverage.note) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    zone.references
                      ? _c(
                          "div",
                          { staticClass: "categorty" },
                          [
                            _c("div", { staticClass: "category-title" }, [
                              _vm._v("REFERENCES")
                            ]),
                            _vm._v(" "),
                            _vm._l(zone.references, function(ref, idx) {
                              return _c(
                                "div",
                                { staticClass: "property-row" },
                                [
                                  _c("label", [
                                    _vm._v(_vm._s(ref.description))
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "property-value-right" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: ref.url,
                                            target: "_blank"
                                          }
                                        },
                                        [
                                          _vm._v("Link "),
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "material-icons md-12"
                                            },
                                            [_vm._v("open_in_new")]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      : _vm._e()
                  ])
                })
              ],
              2
            ),
            _vm._v(" "),
            _vm.token === null
              ? _c(
                  "div",
                  {
                    staticClass: "over-action d-flex",
                    on: { click: _vm.routeLogin }
                  },
                  [_vm._m(3, true)]
                )
              : _vm._e()
          ])
        ])
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "back-btn" }, [
      _c("i", { staticClass: "material-icons md-18" }, [
        _vm._v("keyboard_arrow_left")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lock-icon-box" }, [
      _c("i", { staticClass: "material-icons md-36" }, [_vm._v("account_box")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lock-text" }, [
      _c("h5", { staticClass: "mb-0 text-white" }, [
        _vm._v("Sign in to view zoning")
      ]),
      _vm._v(" "),
      _c("h5", { staticClass: "mb-0 font-weight-light text-light" }, [
        _vm._v("Get details on parcel capabilities")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "over-action-box align-self-center text-white hover-dk" },
      [
        _c("div", { staticClass: "text-center" }, [
          _c("i", { staticClass: "material-icons text-light md-36" }, [
            _vm._v("account_box")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text-center" }, [
          _vm._v("\n\t\t\t\t\t\tSign in to view\n\t\t\t\t\t")
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-170eb0b7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-170eb0b7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parcel/parcel-zoning.vue
// module id = null
// module chunks = 